import React, { useContext, useState } from 'react'
import { Table, Button, Icon } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import IntelMsg from '../ItelMsg'
import { AlertContext } from './alertContext'
import AssignToAssetModal from './assignToAssetModal'

const TemplateTable = ({ templates }) => {
  const { setViewDetails, setTemplate, customerId } = useContext(AlertContext)
  const [open, setOpen] = useState(false)
  const [modalTemplate, setModalTemplate] = useState({})

  const renderTemplates = () => {
    if (templates.length === 0) {
      return <Table.Row>No Data To Show</Table.Row>
    }
    return templates.map((temp, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <Table.Row key={idx}>
        <Table.Cell>{temp['template name']}</Table.Cell>
        <Table.Cell>
          <Button animated size="medium" onClick={() => onDetailsClick(temp)}>
            <Button.Content hidden>
              <IntelMsg id="Details" />
            </Button.Content>
            <Button.Content visible style={{ width: '50px' }}>
              <Icon name="ellipsis horizontal" />
            </Button.Content>
          </Button>

          {false && (
            <Button animated size="medium" onClick={() => onAssignClick(temp)}>
              <Button.Content hidden>Assign</Button.Content>
              <Button.Content visible style={{ width: '50px' }}>
                <Icon name="sign-in" />
              </Button.Content>
            </Button>
          )}
        </Table.Cell>
      </Table.Row>
    ))
  }

  const onAssignClick = (temp) => {
    setModalTemplate(temp)
    setOpen(true)
  }

  const onDetailsClick = (temp) => {
    setTemplate(temp)
    setViewDetails(true)
  }
  return (
    <>
      <Table sortable compact celled basic>
        <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
          <Table.Row>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              Template Name
            </Table.HeaderCell>
            <Table.HeaderCell style={{ textAlign: 'center' }}>
              Actions
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body style={{ textAlign: 'center' }}>
          {renderTemplates()}
        </Table.Body>
      </Table>

      <AssignToAssetModal
        open={open}
        setOpen={setOpen}
        template={modalTemplate}
        customerId={customerId}
      />
    </>
  )
}

TemplateTable.propTypes = {
  templates: Proptypes.array,
}

export default TemplateTable
